function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M0 396c0-64 54-117 120-117h240c66 0 120 53 120 117v116H0zm358-281C358 51 307 0 242 0c-63 0-114 51-114 115 0 62 51 115 114 115 65 0 116-53 116-115z"
})));